import type { FileRejection } from 'react-dropzone';
import { Controller, useFormContext } from 'react-hook-form';
import type { CreateOfferFormData } from '@/views/CreateOffer/types';
import {
  BuyerAgreementDropzoneWidthFileList,
  type BuyerAgreementDropzoneWidthFileListProps,
} from './BuyerAgreementDropzoneWithFileList';

type BuyerAgreementDropzoneWidthFileListFieldProps = Omit<
  BuyerAgreementDropzoneWidthFileListProps,
  'handleDrop'
> & {
  handleDrop?: BuyerAgreementDropzoneWidthFileListProps['handleDrop'];
  acceptedFiles?: File[];
};

export const BuyerAgreementDropzoneWidthFileListField = ({
  handleDrop,
  acceptedFiles = [],
  ...props
}: BuyerAgreementDropzoneWidthFileListFieldProps) => {
  const { control, setValue } = useFormContext<CreateOfferFormData>();
  const onDrop = (
    newAcceptedFiles: File[],
    newRejections: FileRejection[],
    method: 'drop' | 'click',
  ) => {
    setValue('attachment', newAcceptedFiles);
    handleDrop?.(newAcceptedFiles, newRejections, method);
  };

  return (
    <Controller
      control={control}
      name="attachment"
      defaultValue={acceptedFiles}
      render={({ field }) => (
        <BuyerAgreementDropzoneWidthFileList
          handleDrop={onDrop}
          acceptedFiles={field.value ?? []}
          {...props}
        />
      )}
    />
  );
};
